// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"5fa7aa4f","569":"c24e7805"}[chunkId] + ".chunk.css";
};